import { Toaster as SonnerToaster } from 'sonner'

/**
 * App-wide toast surface. Mounted once in the root layout so any
 * `toast(...)` / `toast.error(...)` call from anywhere renders here.
 */
export function GlobalToaster() {
  return (
    <SonnerToaster
      richColors
      closeButton
      theme="dark"
      position="top-right"
      duration={5000}
    />
  )
}
